module.exports = __webpack_public_path__ + "img/P22.cbbaf2a.png";